import { Navigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { useEffect } from 'react';
import { useMaintenanceAccess } from '@/hooks/maintenance/useMaintenanceAccess';

interface MaintenanceProtectedRouteProps {
  children: React.ReactNode;
}

const MaintenanceProtectedRoute = ({ children }: MaintenanceProtectedRouteProps) => {
  const { hasAccess, isLoading } = useMaintenanceAccess();
  const { toast } = useToast();

  useEffect(() => {
    if (!isLoading && !hasAccess) {
      toast({
        title: "Truy cập bị từ chối",
        description: "Bạn không có quyền truy cập trang Bảo trì.",
        variant: "destructive",
      });
    }
  }, [hasAccess, isLoading, toast]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Đang kiểm tra quyền truy cập...</p>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default MaintenanceProtectedRoute;
